<script>
import SpeciesOfInterestBase from './SpeciesOfInterestBase'

export default {
  name: 'SpeciesOfInterestPdf',
  extends: SpeciesOfInterestBase
}
</script>

<template>
  <div
    class="row graceful-page-break"
    :class="{
      rtl: readDirection === 'rtl'
    }"
  >
    <div class="col-1 align-self-center text-center">
      <img
        v-if="getHealthIndicatorImageUrl(speciesData)"
        :src="getHealthIndicatorImageUrl(speciesData)"
        class="health-indicator-icon"
      >
    </div>
    <div class="col-3 align-self-center">
      <span class="species-name">{{ speciesData.displayName }}</span>
    </div>
    <div class="col-3 abundance-meter-labels">
      <div class="float-end">
        <p v-if="containsMultipleSamples">
          {{ i18n.t('badge.a') }}
          <span class="abundance-value float-end">{{
            formattedValue(speciesData.abundanceValue)
          }}</span>
        </p>

        <p v-else>
          {{ i18n.t('badge.you') }}
          <span class="abundance-value float-end">{{
            formattedValue(speciesData.abundanceValue)
          }}</span>
        </p>

        <p v-if="containsMultipleSamples">
          {{ i18n.t('badge.b') }}
          <span class="float-end abundance-value">{{
            formattedValue(speciesData.abundanceValueSecondarySample)
          }}</span>
        </p>
        <p>
          {{ i18n.t('general.average')
          }}<span class="float-end abundance-value">{{
            formattedValue(speciesData.average)
          }}</span>
        </p>
      </div>
    </div>
    <div class="col-5 text-left pr-0">
      <AbundanceMeter
        :enable-tooltip="false"
        :display-y-labels="false"
        :primary-sample="primaryAbundanceValue"
        :secondary-sample="secondaryAbundanceValue"
        :healthy-comparison="healthyCohortComparisonValue"
        :chart-id="componentId"
        :domain-min="domainMin"
        :domain-max="domainMax"
      />
    </div>
  </div>
</template>
<style lang="scss" scoped>
  .rtl {
    .float-end {
      float: left;
    }
  }
  .float-end {
    float: right;
  }
</style>
